<!--
 * @Author: Junjie
 * @Date: 2023-01-13 10:45:50
 * @LastEditTime: 2023-01-13 12:36:24
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/monitor/points/ImportantPoints.vue
-->
<template>
  <div class="page-container flex flex-col">
    <a-row style="padding: 10px;">
      <a-col :span="6">
        <span style="margin-left: 20px">
          选择时间：
          <j-tsdb-time-range :style="{ width: '180px' }" @change="setFastRange" v-model="fastTimeRange" />
        </span>
      </a-col>
      <a-col :span="18">
        <a-radio-group @change="loadPage" buttonStyle="solid" v-model="curReport">
          <a-radio-button :key="item.id" :value="key" v-for="(item, key) in reports">{{ item.label }}</a-radio-button>
        </a-radio-group>
      </a-col>
    </a-row>
    <div :class="['flex-1']">
      <template>
        <iframe-f-report-view
          :mozallowfullscreen="true"
          :msallowfullscreen="true"
          :oallowfullscreen="true"
          :src="iframeSrc"
          allowfullscreen="true"
          frameborder="0"
          ref="commentIframe"
          webkitallowfullscreen="true"
        ></iframe-f-report-view>
      </template>
    </div>
  </div>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { getAction, httpAction } from '@/api/manage'
  import IframeFReportView from '@/components/layouts/IframeFReportView.vue';
  import moment from 'dayjs'

  export default {
    name: 'ImportantPoints',
    components: {
      IframeFReportView,
    },
    data () {
      return {
        description: '实时数据',
        iframeSrc: '',
        reports: [],
        curReport: 0,
        url: {
          getReportList: '/custom/commonOnlReport/list',
        },
        fastTimeRange: "Last 24 hours",
        timeRange: ['now-24h', 'now'],
      }
    },
    created () {
      this.getReportList();
    },
    methods: {
      setFastRange (val) {
        this.timeRange.splice(0, 2, val[0], val[1])
        this.loadPage();
      },
      loadPage () {
        let linkUrl = this.reports[this.curReport].url;
        linkUrl += `&from=${this.timeRange[0]}&to=${this.timeRange[1]}`;
        this.iframeSrc = linkUrl;
      },
      getReportList () {
        const parms = {
          reportGroup: 'imp-points',
          pageSize: 9999,
          clientDevice: 'PC',
          isDisplay: 'Y',
          column: 'orderNum',
          order: 'asc'
        };
        getAction(this.url.getReportList, parms).then((res) => {
          if (res.success) {
            res.result.records.forEach(report => {
              this.reports.push({
                label: report.reportName,
                value: report.id,
                url: report.url,
              });
            });
            this.loadPage();
          }
        });
      },
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

  iframe {
    height: 100%;
  }

</style>
